import { PayloadAction } from '@reduxjs/toolkit';
import { AvailableLanguage } from './types';
import { initialState } from './index';

export const reducers = {
  getAvailableLanguages(state, action: PayloadAction<any>) {
    state.isLoading = true;
  },
  getAvailableLanguagesSuccess(
    state,
    action: PayloadAction<AvailableLanguage[]>,
  ) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getAvailableLanguagesFail(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error =
      action.payload.message ||
      action.payload.statusText ||
      action.payload.status ||
      'error';
  },
};
